<template>
  <div>
    <div class="c-base-transaction-details__price">
      <div class="c-base-transaction-details__icon has-text-error">
        <base-icon width="24" height="24" :name="icon" />
      </div>
      <span v-if="amountTotal > 0" class="c-base-transaction-details__discount">
        - {{ amountTotal | currency }}
      </span>
      <div class="c-base-transaction-details__amount has-text-error">
        - {{ transaction.amount | currency }}
      </div>

      <p class="c-base-transaction-details__category">
        <strong>Compra</strong><br />
        Shopping Casar.com
        <br />
        <small>Realizada em {{ transaction.created_at | date }}</small>
      </p>
    </div>

    <div
      class="c-base-transaction-details__body c-base-transaction-details--body-orders"
    >
      <div
        v-for="(order, index) in orders"
        :key="index"
        class="columns is-mobile is-gapless is-multiline is-vcentered margin-bottom"
      >
        <div class="column is-half">
          <p class="is-size-6 has-text-weight-bold is-flex">
            Total em {{ order.supplier_name }}
            <span
              class="icon tooltip is-tooltip-multiline"
              data-tooltip="Valor referente à soma de produtos e fretes comprados no shopping Casar.com. Mais informações em “Acessar meus pedidos”."
            >
              <base-icon width="1.2em" height="1.2em" name="painel/help-icon" />
            </span>
          </p>
        </div>
        <div class="column is-half has-text-right">
          <strong class="is-size-6 has-text-error">
            -{{ (order.product + order.shipping) | currency }}
          </strong>
        </div>
        <div class="column is-half" height="1.5em">
          <p>Produtos:</p>
        </div>
        <div class="column is-half has-text-right">
          <strong>-{{ order.product | currency }}</strong>
        </div>
        <div class="column is-half">
          <p>Frete:</p>
        </div>
        <div v-if="order.shipping == 0" class="column is-half has-text-right">
          <strong class="has-text-support"> Grátis </strong>
        </div>
        <div v-else class="column is-half has-text-right">
          <strong> -{{ order.shipping | currency }} </strong>
        </div>
        <div class="margin-bottom">
          <a
            @click="
              userValidateToRedirect('details', '', order.external_order_id)
            "
            target="_blank"
            class="c-base-transaction-details has-text-underline"
            >Ver detalhes do pedido {{ order.external_order_id }}</a
          >
        </div>
      </div>
      <div
        v-if="discount > 0"
        class="columns is-mobile is-gapless is-multiline margin-bottom"
      >
        <div class="column">
          <p class="is-size-6">
            <strong>Descontos</strong>
          </p>
          <div class="columns is-mobile is-gapless is-multiline margin-bottom">
            <div class="column is-half">
              <p class="is-size-6">Pagamento com bônus</p>
            </div>
            <div class="column is-half has-text-right">
              <strong class="is-size-6">
                {{ discount | currency }}
              </strong>
            </div>
          </div>
        </div>
      </div>

      <div class="c-base-transaction-details__price">
        <p class="c-base-transaction-details has-text-support">
          Esse pedido gerou {{ cashbackAmountToReceive | currency }} (4%) de
          cashback
        </p>
        <small class="has-text-support">
          O valor do cashback é liberado 10 dias após a compra
        </small>
      </div>
    </div>
  </div>
</template>

<script>
import BaseTransactionDetailsMixin from '@/mixins/BaseTransactionDetailsMixin'
import verifyDataUserMixin from '@/mixins/verifyDataUserMixin'
import WalletApi from '@/lib/api/Wallet'

export default {
  mixins: [BaseTransactionDetailsMixin, verifyDataUserMixin],

  props: {
    transaction: {
      type: Object,
      required: true,
    },
    icon: String,
    discount: Number,
    amountTotal: Number,
  },

  computed: {
    logonToken() {
      return this.$store.state.app.logonToken
    },

    externalToken() {
      return this.$store.state.wallet.externalToken
    },

    orderDetailsUrl() {
      return this.shoppingUrl + this.externalToken + this.shoppingReturnUrl
    },

    walletSummary() {
      return this.$store.state.wallet.walletSummary
    },
  },

  data() {
    return {
      orders: [],
      cashbackAmountToReceive: 0,
    }
  },

  mounted() {
    this.getOrders()
  },

  methods: {
    getOrders() {
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .getOrders(this.transaction.transaction_id)
        .then(
          (response) => (
            (this.orders = response.data.data.orders),
            (this.cashbackAmountToReceive = response.data.data.cashback_amount)
          )
        )
        .catch((error) => console.error(error))
    },

    getCashbacks() {
      const walletApi = new WalletApi(this.logonToken)
      walletApi
        .getCashbacks(this.transaction.reference_id)
        .then((response) => {
          this.cashbacks = response.data.data
          this.cashbacksLoadeds
        })
        .catch((error) => console.error(error))
    },

    userValidateToRedirect(params, redirectTypeName, order_id) {
      if (this.verifyDataUser()) {
        this.goTo(params, redirectTypeName, order_id)
      } else {
        this.$refs.CPFModalPix.open()
      }
    },
  },
}
</script>
